module.exports = __webpack_public_path__ + "img/arrow_right_primary.3a44bd7e.svg";